<div class="page-header">
  <div class="grid-container">
    {{changeRequestID}}
  </div>
</div>
<div class="grid-container">
<div class="content-header">Domain: {{domainName | domainNameConverter}}</div>
<div class="content content-with-elevation" style="margin-top: 24px">
  <div class="grid-x content">
    <div class="cell medium-10 large-10 small-12" style="display: flex; flex-direction: column">
      <span class="content-sub-header">Technical check results from {{techCheckResult?.statusCheck?.completed | commonDate}}</span>
      <a class="a-link" target="_blank" (click)="openLog()">Click here to view Full Technical Check Log</a>
    </div>
    <div class="cell large-2 medium-2 small-12  {{techCheckResult.result | techCheckCssHelper}}" style="display: flex; justify-content: center; align-items: center">{{techCheckResult.result}}</div>
  </div>
  <div class="content-header">Test Results</div>
  <div *ngFor="let result of  techCheckResult.statusCheck && techCheckResult.statusCheck.results;" style="margin-top: 24px">
    <tech-check-result [techCheckResult]="result"></tech-check-result>
  </div>
</div>
</div>
